<!-- Don't touch tag that contains ids, cause they are used in unit test -->
<div class="container">
  <div>
    <strong> Add / Remove tags dynamically: </strong>
    <ui-tag *ngFor="let tag of tags; let i = index" [uiMode]="i === 0 ? 'default' : 'closeable'" (uiOnClose)="handleClose(tag)">
      {{ sliceTagName(tag) }}
    </ui-tag>
    <ui-tag *ngIf="!inputVisible" class="editable-tag" uiNoAnimation (click)="showInput()">
      <ui-icon uiType="outline:plus"></ui-icon>
      New Tag
    </ui-tag>
    <input #inputElement ui-input uiSize="small" *ngIf="inputVisible" type="text" [(ngModel)]="inputValue" style="width: 78px" (blur)="handleInputConfirm()" (keydown.enter)="handleInputConfirm()" />
  </div>
  <div>
    <strong> With icon: </strong>
    <ui-tag uiColor="success">
      <ui-icon uiType="outline:check-circle"></ui-icon>
      <span>success</span>
    </ui-tag>
    <ui-tag id="color" uiColor="processing">
      <ui-icon uiType="outline:sync" [uiSpin]="true"></ui-icon>
      <span>processing</span>
    </ui-tag>
    <ui-tag uiColor="error">
      <ui-icon uiType="outline:close-circle"></ui-icon>
      <span>error</span>
    </ui-tag>
    <ui-tag uiColor="warning">
      <ui-icon uiType="outline:exclamation-circle"></ui-icon>
      <span>warning</span>
    </ui-tag>
    <ui-tag uiColor="default">
      <ui-icon uiType="outline:clock-circle"></ui-icon>
      <span>default</span>
    </ui-tag>
  </div>
  <div>
    <strong> Checkable: </strong>
    <ui-tag id="checkable" uiMode="checkable" [uiChecked]="true" (uiCheckedChange)="checkChange($event)">Tag1</ui-tag>
    <ui-tag uiMode="checkable" [uiChecked]="false" (uiCheckedChange)="checkChange($event)">Tag2</ui-tag>
    <ui-tag uiMode="checkable" [uiChecked]="true" (uiCheckedChange)="checkChange($event)">Tag3</ui-tag>
  </div>
</div>
